export default __webpack_public_path__ + "static/media/gridview_active.9684fa16.svg";